import React, { useState } from 'react'
import { useDispatch } from 'react-redux'

import { POST_CARD_FEEDBACK_ASYNC } from 'containers/SpearPhishingAgent/constants'

import FeedbackRatingControl from 'components/lib/FeedbackRating/FeedbackRatingControl'
import {
  PSIMA_PENDO_FEATURES,
  trackPsimaFeedbackSubmitted,
} from 'components/pages/SpearPhishingAgent/psimaPendo'

const LOCAL_STORAGE_KEY = 'psima-card-feedback'

const readFeedbackMap = () => {
  try {
    const raw = window.localStorage.getItem(LOCAL_STORAGE_KEY)
    if (!raw) return {}
    const parsed = JSON.parse(raw)
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch (e) {
    console.error(e)
    return {}
  }
}

const writeFeedbackMap = (map) => {
  try {
    window.localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(map))
  } catch (e) {
    console.error(e)
  }
}

const FeedbackRating = ({ cardId }) => {
  const dispatch = useDispatch()
  const [selectedSide, setSelectedSide] = useState(() => {
    const map = readFeedbackMap()
    if (!Object.hasOwn(map, cardId)) return null
    return map[cardId] ? 'like' : 'dislike'
  })

  const persistSide = (side) => {
    const isLike = side === 'like'
    writeFeedbackMap({ ...readFeedbackMap(), [cardId]: isLike })
    setSelectedSide(side)
    trackPsimaFeedbackSubmitted({
      target: 'suggestion',
      reviewSide: isLike ? 'up' : 'down',
    })
  }

  const handleLike = () => {
    persistSide('like')
    dispatch(POST_CARD_FEEDBACK_ASYNC.initiate({ cardId, reviewSide: true }))
  }

  const handleDislike = (comment) => {
    persistSide('dislike')
    dispatch(POST_CARD_FEEDBACK_ASYNC.initiate({ cardId, reviewSide: false, comment }))
  }

  return (
    <FeedbackRatingControl
      itemId={cardId}
      idPrefix="Psima_Dashboard"
      selected={selectedSide}
      onLike={handleLike}
      onDislike={handleDislike}
      pendoFeatureUp={PSIMA_PENDO_FEATURES.DASHBOARD_FEEDBACK_UP}
      pendoFeatureDown={PSIMA_PENDO_FEATURES.DASHBOARD_FEEDBACK_DOWN}
    />
  )
}

export default FeedbackRating
